<div fxLayout="column" fxLayoutGap="16px">
	<claim-tag-combo-select-ctrl [caption]="'documents.sharedClaimLinks.tag'"
		[formControlName]="'tag'" [allowCustom]="false" [settings]="{fxFill:true, readonly: readonlyFields}">
	</claim-tag-combo-select-ctrl>

	<date-time-input-ctrl [caption]="'documents.sharedClaimLinks.expirationDate'"
		[formControlName]="'expirationDate'" [settings]="{fxFill:true, readonly: readonlyFields}">
	</date-time-input-ctrl>

	<!-- <text-input-ctrl [caption]="'documents.sharedClaimLinks.pinCode'" [formControlName]="'pinCode'"
		[settings]="{fxFill:true}"></text-input-ctrl> -->

	<div *ngIf="editMode" class="shared-claim-document-link-info">
		<kendo-textarea [value]="('documents.sharedClaimLinks.accessInfo' | translate: {
			link: sharedDocumentLink,
			pin: pinCode
		})" [readonly]="true" [rows]="5">
		</kendo-textarea>

		<div class="shared-claim-document-link-copy" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
			<kendo-textbox [value]="sharedDocumentLink" [readonly]="true"></kendo-textbox>
			<button kendoButton fillMode="flat" title="Copy" [cdkCopyToClipboard]="sharedDocumentLink"
				icon="share" (click)="copyLink()">
			</button>
		</div>
	</div>
</div>
